import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { OverlayModule } from '@angular/cdk/overlay';

import { SHARED_MATERIAL_MODULES } from './shared-material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NGX_FORMLY_COMPONENTS, NGX_FORMLY_CONFIG, NGX_FORMLY_MODULES } from './ngx-formly.module';
import { ProgressComponent } from './components/dialog/progress.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { PatientDetailPopupComponent } from './components/popup/patient-detail-popup/patient-detail-popup.component';
import { MovementHistoryPopupComponent } from './components/popup/movement-history-popup/movement-history-popup.component';
import { AlertCardComponent } from './components/card/alert-card/alert-card.component';
import { PatientCardComponent} from './components/card/patient-card/patient-card.component';
import { NewPatientCardComponent } from './components/card/new-patient-card/new-patient-card.component';
import { FormlyModule } from '@ngx-formly/core';
import { HeartRateChartComponent } from './components/chart/heart-rate-chart/heart-rate-chart.component';
import { AlertHistoryPanelComponent } from './components/alert-history-panel/alert-history-panel.component';
import { HospitalLangPipe } from 'src/app/core/i18n/hospital-lang.pipe';


// 拡張ライブラリ
const THIRD_MODULES: Type<any>[] = [
  FlexLayoutModule,
  ...NGX_FORMLY_MODULES,
];

// 共有コンポーネント
const COMPONENTS: Type<any>[] = [
  // ローディング
  ProgressComponent,
  DialogComponent,
  PatientDetailPopupComponent,
  MovementHistoryPopupComponent,
  AlertCardComponent,
  PatientCardComponent,
  NewPatientCardComponent,
  HeartRateChartComponent,
  AlertHistoryPanelComponent,
  ...NGX_FORMLY_COMPONENTS,
];

// Angularのモジュール
const ANGULAR_MODULES: Type<any>[] = [
  CommonModule,
  FormsModule,
  RouterModule,
  ReactiveFormsModule,
  OverlayModule,
];

@NgModule({
  declarations: [
    ...COMPONENTS,
  ],
  imports: [
    // ngx-formlyの拡張
    FormlyModule.forRoot(NGX_FORMLY_CONFIG as any),
    HospitalLangPipe,
    ...SHARED_MATERIAL_MODULES,
    ...ANGULAR_MODULES,
    ...THIRD_MODULES,
  ],
  exports: [
    ...ANGULAR_MODULES,
    FormlyModule,
    HospitalLangPipe,
    ...SHARED_MATERIAL_MODULES,
    ...THIRD_MODULES,
    ...COMPONENTS,
  ]
})

export class SharedModule { }
